import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type Holiday = {
  id: string;
  date: string; // ISO ("YYYY-MM-DDT00:00:00.000Z")
  nom: string;
  recurring: boolean;
};

/**
 * Jours fériés d'une année — signalés en UI (couleur), JAMAIS bloquants
 * (décision Jalal 2026-06-03 : ils changent souvent). Endpoint accessible à
 * tous les rôles connectés.
 */
export function useHolidays(year: number, enabled = true) {
  return useQuery({
    queryKey: ['holidays', year],
    queryFn: () => api.get<{ holidays: Holiday[] }>(`/holidays?year=${year}`),
    select: (d) => d.holidays,
    enabled,
    staleTime: 60 * 60_000,
  });
}

/**
 * Trouve le férié correspondant à une date ISO ("YYYY-MM-DD"), s'il y en a un.
 * Récurrent → compare mois-jour ; ponctuel → compare la date exacte.
 */
export function findHoliday(holidays: Holiday[] | undefined, iso: string): Holiday | undefined {
  if (!holidays || holidays.length === 0) return undefined;
  const mmdd = iso.slice(5, 10);
  return holidays.find((h) =>
    h.recurring ? h.date.slice(5, 10) === mmdd : h.date.slice(0, 10) === iso,
  );
}
